import React, { ChangeEvent } from 'react';
import './FilterSelect.css';

export interface FilterOption {
  value: string;
  label: string;
}

export interface FilterSelectProps {
  /** Current selected value */
  value: string;
  /** Called when selection changes */
  onChange: (value: string) => void;
  /** Available options */
  options: FilterOption[];
  /** Placeholder text (shown as first disabled option) */
  placeholder: string;
  /** Accessibility label */
  ariaLabel?: string;
  /** Whether to show visual active state when value is selected */
  showActiveState?: boolean;
  /** Additional CSS class name */
  className?: string;
  /** Whether the select is disabled */
  disabled?: boolean;
}

/**
 * Reusable filter select dropdown with optional active state styling.
 */
export const FilterSelect: React.FC<FilterSelectProps> = ({
  value,
  onChange,
  options,
  placeholder,
  ariaLabel,
  showActiveState = true,
  className = '',
  disabled = false,
}) => {
  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
  };

  const isActive = showActiveState && value !== '';

  return (
    <select
      className={`filter-select ${isActive ? 'filter-active' : ''} ${className}`}
      value={value}
      onChange={handleChange}
      aria-label={ariaLabel || placeholder}
      disabled={disabled}
    >
      <option value="">{placeholder}</option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default FilterSelect;
